import yup from '../yup';

export const updateUserSchema = yup.object().shape({
  name: yup.string()
    .nullable()
    .required('Please enter your first name')
    .label('name'),
  surname: yup.string()
    .nullable()
    .required('Please enter your last name')
    .label('surname'),
  nameKana: yup.string()
    .nullable()
    .label('nameKana'),
  surnameKana: yup.string()
    .nullable()
    .label('surnameKana'),
  postCode: yup.string()
    .nullable()
    .label('postCode'),
  stateCity: yup.string()
    .nullable()
    .label('stateCity'),
  streetBanNumber: yup.string()
    .nullable()
    .label('streetBanNumber'),
  buildingNumber: yup.string()
    .nullable()
    .label('buildingNumber'),
  phone: yup.string()
    .nullable()
    .label('phone'),
});
